import { render } from "./profile-blocks.vue?vue&type=template&id=70920c76&scoped=true"
import script from "./profile-blocks.vue?vue&type=script&lang=js"
export * from "./profile-blocks.vue?vue&type=script&lang=js"

import "./profile-blocks.vue?vue&type=style&index=0&id=70920c76&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70920c76"]])

export default __exports__